import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { ArrowLeft } from "lucide-react";
import { usePageTitle } from "../lib/usePageTitle";
import { useLocalePath } from "../lib/useLocalePath";

export default function NotFound() {
    usePageTitle("meta.notfound");
    const { t } = useTranslation();
    const lp = useLocalePath();

    return (
        <main
            data-testid="page-not-found"
            className="min-h-screen flex items-center px-6 md:px-12 lg:px-20 pt-32 pb-24"
        >
            <div className="max-w-2xl">
                <p className="text-[10px] uppercase tracking-[0.35em] text-[#C5A059]">
                    {t("notfound.overline")}
                </p>
                <h1 className="mt-6 font-heading text-6xl md:text-7xl lg:text-8xl text-[#E8E3D9] leading-[0.95] tracking-tight">
                    {t("notfound.h1_a")}{" "}
                    <span className="italic text-[#C5A059]">
                        {t("notfound.h1_b")}
                    </span>
                </h1>
                <p className="mt-8 max-w-xl text-[#A39E93] text-base md:text-lg font-light leading-relaxed">
                    {t("notfound.body")}
                </p>
                <div className="mt-12 flex flex-wrap items-center gap-4">
                    <Link
                        to={lp("/")}
                        data-testid="notfound-home-link"
                        className="inline-flex items-center gap-3 bg-[#C5A059] text-[#0D0D0D] px-8 py-4 text-[11px] uppercase tracking-[0.25em] font-medium hover:bg-[#E8E3D9] transition-colors"
                    >
                        <ArrowLeft size={14} />
                        {t("notfound.cta_home")}
                    </Link>
                    <Link
                        to={lp("/products")}
                        data-testid="notfound-products-link"
                        className="inline-flex items-center gap-3 border border-[#C5A059] text-[#C5A059] px-8 py-4 text-[11px] uppercase tracking-[0.25em] hover:bg-[#C5A059] hover:text-[#0D0D0D] transition-colors"
                    >
                        {t("notfound.cta_products")}
                    </Link>
                </div>
            </div>
        </main>
    );
}
